import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterModule, BypassSecurityPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.less',
  standalone: true
})
export class FooterComponent {
  public footer$!: Observable<any>;
  currentYear: number = new Date().getFullYear();

  private readonly store = inject(Store);

  ngOnInit(): void {
    this.footer$ = this.store.select((state) => {

      console.log(state.glkobalData?.footer);
      return state.globalData?.footer;
    });
  }
}
